import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, Subscription, of } from 'rxjs';
import { catchError, map, skipWhile, switchMap, take } from 'rxjs/operators';
import {
  COOKIE,
  DEFAULT_CULTURE,
  DirittiFdu,
  ENUM_FILE_DATA_TYPES_BASE64_PREFIX,
  Environment,
  FunzioniDivisioneUtente,
  IClientNg,
  JwtUser,
  ModelNumBytes,
  SESSION,
  SysImpostazioniUtente,
  TRADUZIONI_CONSENTITE,
} from '../../models/-index';
import { JwtHelperService } from './jwt-helper.service';

import { CookieService } from 'ngx-cookie-service';

interface SessionsStorage {
  key: string;
  type: string;
}

@Injectable({
  providedIn: 'root',
})
export class SecurityService implements OnDestroy {
  private subscriptions: Subscription[] = [];
  private _jwthelper = new JwtHelperService();

  // private h = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
  // private hi = new HttpHeaders({ 'Content-Type': 'image/png' });
  private baseUrlfdu: string;
  private baseUrl_SysImpostaUtente: string;

  // public _ret: boolean;
  // public utente: Utenti;
  // fdu: FunzioniDivisioneUtente[];
  // usr: Utenti;
  /*
  new_diritti: FunzioniDivisioneUtente = {
    IdFunDiUte: 0,
    IdFunzione: '-',
    IdDivisione: 0,
    IdUtente: '-',
    Visualizza: false,
    Modifica: false,
    Elimina: false,
    IdDivisioneNavigation: null,
    IdFunzioneNavigation: null,
    IdUtenteNavigation: null,
  };*/

  public subj_Logo$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public Logo$: Observable<string> = this.subj_Logo$.asObservable();
  /*public storedModulo: string;

  private _store_fdu = new BehaviorSubject<FunzioniDivisioneUtente[]>([]);
  ModuloFdu$: Observable<FunzioniDivisioneUtente[]> = this._store_fdu.asObservable();*/

  // -------- diritti ------- //

  private subj_DirittiAllFdu$: BehaviorSubject<DirittiFdu[]> = new BehaviorSubject<DirittiFdu[]>([]);
  private DirittiAllFdu$: Observable<DirittiFdu[]> = this.subj_DirittiAllFdu$.asObservable();

  constructor(
    @Inject('ENV') private env: Environment,
    private _http: HttpClient,
    private _cookie: CookieService,
    private _router: Router
  ) {
    //   this.httpOptionsJson = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
    /* this.httpOptionsNoAuth = {
      headers: new HttpHeaders().set('No-Auth', 'true'),
    };*/
    this.baseUrlfdu = this.env.apiUrl + '/api/FunzioniDivisioneUtente/';
    this.baseUrl_SysImpostaUtente = this.env.apiUrl + '/api/SysImpostazioniUtente/';
  }

  // ======= metodo principale che prende i diritti senza richiederli al server ============
  /*
  Diritti$(funzione: string): Observable<FunzioniDivisioneUtente> {
    return this.ModuloFdu$.pipe(
      map((txs) => {
        //onsole.log('ModuloFdu--->' + JSON.stringify(txs, null, 4));
        const f = txs.find((x) => x.IdFunzione == funzione);
        if (f) {
          return f;
        } else {
          if (this._store_fdu && this._store_fdu.value) {
            //onsole.log('- this._store_fdu.value-->' + JSON.stringify(this._store_fdu.value, null, 4));
            if (this._store_fdu.value.length > 0) {
              //onsole.log('- this._store_fdu.value-length->' + JSON.stringify(this._store_fdu.value, null, 4));
              this._t
                .selectTranslate('err.no-auth-func')
                .pipe(take(1))
                .subscribe((m) => this._toast.error(m + funzione, { autoClose: false, dismissible: true }));
            }
          }
        }
      })
    );
  } */
  // oooooooooooooooooooo METODI PRINCIPALI NEW ooooooooooooooooooooooooooooo
  // metodo principale che prende i diritti senza richiederli al server , solo all'inizio
  // se settata l'area in navbar usare questo metodo

  Diritti$(funzione: string): Observable<DirittiFdu> {
    return this.DirittiAllFdu$.pipe(
      skipWhile((res: DirittiFdu[]) => res.length == 0),
      take(1),
      map((txs) => {
        //onsole.log('Diritti-txs-->' + JSON.stringify(txs, null, 4));
        return txs.find((x) => x.IdFunzione == funzione);
      })
    );
  }
  GetDirittiMulti$(funzioni: string[]): Observable<DirittiFdu> {
    return this.DirittiAllFdu$.pipe(
      skipWhile((res: DirittiFdu[]) => res.length == 0),
      take(1),
      map((txs) => {
        const _filter = txs.filter((funz) => funzioni.includes(funz.IdFunzione));
        //onsole.log('-txs multi>' + JSON.stringify(txs, null, 4));
        if (_filter) {
          return _filter[0];
        } else {
          return <DirittiFdu>{
            IdFunzione: 'NOT',
            Visualizza: false,
            Modifica: false,
            Elimina: false,
            Limitazione: false,
          };
        }
      })
    );
  }
  // ----- diritti versione 2023 ------//
  // lancialta all'avvio per il reload della pagina prende tutti i diritti
  // lancialta dopo il login per sostituire eventuali dirittie sistenti
  public AppInitAllDirittiFDU(): Observable<string> {
    const _ret = this._cookie.get(COOKIE.SYS_JWT);
    if (!_ret || _ret.length == 0) {
      return of('login');
    }

    //  const val = this.subj_DirittiAllFdu$.value || [];
    // if (val.length == 0) {
    return this.GetAllDirittiFDU().pipe(
      take(1),
      switchMap((x: DirittiFdu[]) => {
        // store diritti
        this.subj_DirittiAllFdu$.next(x);
        return of('loaded all DirittiFdu[]');
      })
    );
    // } else {
    //   return of('exists DirittiFdu[]' + JSON.stringify(val));
    //   }
  }

  // immagazzina logo
  StoreLogo() {
    // se non c'è il jwtuser non legge e l'interceptor manda in login
    const ohhh = this.Get_JwtUser();
    if (ohhh) {
      this.apiGetLogoWeb().subscribe((x: string) => {
        this.subj_Logo$.next(x);
      });
    }
  }

  // ========== richiesta server =============

  // chiamata in avvio per immagazzinare il logo
  // nb: è la stessa di azbase-aservice
  private apiGetLogoWeb(): Observable<string> {
    const u = `${this.env.apiUrl}/api/System/GetLogoWeb`;

    return this._http.get<ModelNumBytes>(u).pipe(
      take(1),
      map((x: ModelNumBytes) => {
        if (x && x.Bytes) {
          return ENUM_FILE_DATA_TYPES_BASE64_PREFIX.JPEG + x.Bytes.toString();
        } else {
          return null;
        }
      })
    );
  }

  // chiamata sopra
  private GetDiritti_byModulo(modulo: string): Observable<FunzioniDivisioneUtente[]> {
    const u = this.baseUrlfdu + 'GetDiritti_byModulo?modulo=' + modulo;
    return this._http.get<FunzioniDivisioneUtente[]>(`${u}`);
  }
  private GetAllDirittiFDU(): Observable<DirittiFdu[]> {
    const u = `${this.baseUrlfdu}GetAllDirittiFDU`;
    return this._http.get<DirittiFdu[]>(u);
  }
  // chiamata diretta
  public GetDirittiFDU_byFunzione$(id: string): Observable<DirittiFdu> {
    const u = `${this.baseUrlfdu}GetDirittiFDU_byFunzione?id=${id}`;
    return this._http.get<DirittiFdu>(u);
  }

  // =============== get con i cookies ==========
  // >>> : utente

  public Get_JwtUser(): JwtUser {
    const _ret = this._cookie.get(COOKIE.SYS_JWT);
    if (!_ret) {
      this._router.navigate(['/auth/login']);
      return null;
    } else {
      const jwtuser = this.format_schemas(JSON.stringify(this._jwthelper.decodeToken(_ret)));
      return jwtuser;
    }
  }

  // >> : ClientSettings
  public Get_ClientSettings(): IClientNg {
    const _ret = this._cookie.get(COOKIE.SYS_SETTINGS);
    if (!_ret) {
      this.redirecTtoLogin();
    } else {
      const dec64 = atob(_ret);
      const _value: IClientNg = JSON.parse(dec64);
      //   this._store_json_settings.next(_value);
      return _value;
    }
  }
  // >> singolo  setting paginator
  GetSetting_PaginatorItemsPerPage(): number {
    const _ret = this._cookie.get(COOKIE.SYS_SETTINGS);

    if (!_ret) {
      this.redirecTtoLogin();
    } else {
      const dec64 = atob(_ret);
      const _value: IClientNg = JSON.parse(dec64);
      const n: number = Number(_value.PaginatorItemsPerPage);
      if (n > 0) {
        return n;
      } else {
        console.error('NG.SEC.SET.ER.00 ERROR: parameter PaginatorItemsPerPage has invalid value: ' + n);
        this.redirecTtoLogin();
      }
    }
  }

  redirecTtoLogin() {
    this.Clean_SystemCookies();

    console.warn('NG.SEC.ER.02 ===>  redirecTtoLogin  this._security.Clean_SystemCookies();');

    this._router.navigateByUrl('/auth/login');
    // location.reload();
  }
  GetSetting_CustomCode(): string {
    const _ret = this._cookie.get(COOKIE.SYS_SETTINGS);

    if (!_ret) {
      return '';
    } else {
      const dec64 = atob(_ret);
      const _value: IClientNg = JSON.parse(dec64);
      return _value.CustomCode;
    }
  }
  // ---- culture -----------
  // get culture :  tenta in preferences poi tenta altro metodo

  public Get_Culture(): string {
    // 3 modi per trovare al culture
    let lng = this._cookie.get(COOKIE.SYS_CULTURE);
    if (lng) {
      return lng;
    }
    const jwt = this._cookie.get(COOKIE.SYS_JWT);
    if (jwt) {
      const jwtuser: JwtUser = this.format_schemas(JSON.stringify(this._jwthelper.decodeToken(jwt)));
      lng = jwtuser.culture;
      return lng;
    }
    lng = this.getWeBrowserCulture();
    if (lng) {
      return lng;
    } else {
      return DEFAULT_CULTURE;
    }
  }

  public Set_CultureCookie(lng: string): void {
    this._cookie.set(COOKIE.SYS_CULTURE, lng, 3650, '/', window.location.hostname, false, 'Lax');
  }

  private getWeBrowserCulture(): string {
    const browserLang = navigator.language;
    const traductions: string[] = TRADUZIONI_CONSENTITE;
    const ln = browserLang.split('-');
    if (traductions.includes(ln[0])) {
      return ln[0];
    } else {
      return DEFAULT_CULTURE;
    }
  }

  public Refresh_JwtToken(tok: string) {
    const prima = this.Get_JwtUser();
    //onsole.log('--prima->' + JSON.stringify(prima, null, 4));
    console.warn('NG.SEC.JWT.WAR.03  CALLED: Refresh_JwtToken');
    if (tok) {
      this._cookie.delete(COOKIE.SYS_JWT, window.location.hostname);
      this._cookie.set(COOKIE.SYS_JWT, tok, 365, '/', window.location.hostname, false, 'Lax');
    }
    const dopo = this.Get_JwtUser();
    //onsole.log('--dopo->' + JSON.stringify(dopo, null, 4));
  }

  public Clean_SystemCookies() {
    console.warn('NG.SEC.JWT.WAR.04  CALLED: Clean_SystemCookies deleted');
    this._cookie.delete(COOKIE.SYS_JWT, window.location.hostname);
    this._cookie.delete(COOKIE.SYS_SETTINGS, window.location.hostname);
    if (localStorage.getItem('delete_cache') === null) {
      localStorage['delete_cache'] = true;
      window.location.reload();
    } else {
      localStorage.removeItem('delete_cache');
    }
  }
  public Store_ClientSettingsModified(item: IClientNg) {
    const str = JSON.stringify(item);
    const en64 = btoa(str);
    this._cookie.set(COOKIE.SYS_SETTINGS, en64, 365, '/', window.location.hostname, false, 'Lax');
  }
  // ---------- IMAGES ---------
  GetSetting_UploadVirtualPathAttachments(): string {
    const e = this.env;
    const _ret = this._cookie.get(COOKIE.SYS_SETTINGS);

    if (_ret) {
      return e.apiUrl;
    } else {
      const dec64 = atob(_ret);
      const _value: IClientNg = JSON.parse(dec64);
      const n: string = _value.UploadVirtualPathAttachments;
      return e.apiUrl + n;
    }
  }
  GetSetting_UploadVirtualPathApplication(): string {
    const e = this.env;
    const _ret = this._cookie.get(COOKIE.SYS_SETTINGS);

    if (!_ret) {
      return e.apiUrl;
    } else {
      const dec64 = atob(_ret);
      const _value: IClientNg = JSON.parse(dec64);
      const n: string = _value.UploadVirtualPathApplication;
      return e.apiUrl + n;
    }
  }
  SysImpostazioniUtente_GetByChiave(chiave: string): Observable<SysImpostazioniUtente> {
    const url = this.baseUrl_SysImpostaUtente + 'GetSingle_ByChiave?chiave=' + chiave;
    return this._http.get<any>(`${url}`);
  }

  SysImpostazioniUtente_TypeBooleanGetByChiave(chiave: string): Observable<boolean> {
    const url = this.baseUrl_SysImpostaUtente + 'GetSingle_ByChiave?chiave=' + chiave;
    return this._http.get<SysImpostazioniUtente | null>(`${url}`).pipe(
      switchMap((item: SysImpostazioniUtente | null) => {
        if (item == null) {
          return of(false);
        } else {
          if (item.Valore == 'true') {
            return of(true);
          } else {
            return of(false);
          }
        }
      })
    );
  }

  SysImpostazioniUtente_AddOrUpdateByModelChiave(model: SysImpostazioniUtente) {
    const url = this.baseUrl_SysImpostaUtente + 'AddOrUpdate_ByModelChiaveUtente';
    return this._http.post(`${url}`, model);
  }
  // --------------------- UTILITA' ------------------
  private format_schemas(json_string) {
    return JSON.parse(json_string, function (key, value) {
      if (!key.startsWith('http://schemas')) {
        return value;
      }
    });
  }
  // non uate ???
  BaseUrl(): string {
    let _baseurl: string;
    if (this.env.production) {
      if (window.location.port.toString().length > 0) {
        _baseurl = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port;
      } else {
        _baseurl = window.location.protocol + '//' + window.location.hostname;
      }
    } else {
      _baseurl = this.env.apiUrl;
      const lastChar = _baseurl[_baseurl.length - 1];
      if (lastChar === '/') {
        _baseurl = _baseurl.substring(0, _baseurl.length - 1);
      }
    }
    return _baseurl;
  }
  GetCurrentBaseUrl(): string {
    let _baseurl: string;

    if (window.location.port.toString().length > 0) {
      _baseurl = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port;
    } else {
      _baseurl = window.location.protocol + '//' + window.location.hostname;
    }

    return _baseurl;
  }
  envIsProduction(): boolean {
    return this.env.production;
  }

  // ====================== ex uty =============
  // per visualizzare le righe disattivate (imposta il session)
  SessionSwitch_boolean(name: string, force_remove: boolean = false): boolean {
    if (force_remove === true) {
      sessionStorage.removeItem(name);
      return false;
    } else {
      const r = sessionStorage.getItem(name);
      if (!r) {
        sessionStorage.setItem(name, '#');
        return true;
      } else {
        sessionStorage.removeItem(name);
        return false;
      }
    }
  }
  // visualizza le righe disattive
  Session_BooleanValue(name: string, set_string_true_or_false: string = null, force_remove: boolean = false): boolean {
    if (force_remove === true) {
      sessionStorage.removeItem(name);
      return false;
    }
    // set mode
    if (set_string_true_or_false != null) {
      if (set_string_true_or_false == 'true') {
        sessionStorage.setItem(name, set_string_true_or_false);
        return true;
      } else if (set_string_true_or_false == 'false') {
        sessionStorage.setItem(name, set_string_true_or_false);
        return false;
      } else {
        console.error('NG.SEC.SES.ERR.PAR err: parameter not correct > ' + set_string_true_or_false);
      }
    } else {
      // get mode
      const r = sessionStorage.getItem(name);
      if (!r) {
        return false;
      } else if (r == 'true') {
        return true;
      } else if (r == 'false') {
        return false;
      } else {
        return false;
      }
    }
  }
  // visualizza le righe disattive
  Session_SearchValue(set_string: string = null, force_remove: boolean = false): string | null {
    const name = SESSION.SEARCH;
    if (force_remove === true) {
      sessionStorage.removeItem(name);
      return null;
    }
    // set mode
    if (set_string != null) {
      sessionStorage.setItem(name, set_string);
      return set_string;
    } else {
      // get mode
      const r = sessionStorage.getItem(name);
      if (!r) {
        return null;
      } else {
        return r;
      }
    }
  }
  Session_boolean(name: string): boolean {
    const r = sessionStorage.getItem(name);
    if (!r) {
      return false;
    } else {
      return true;
    }
  }
  Session_Number(value: any = null, force_remove: boolean = false): number | null {
    const name = SESSION.NUMBER;
    if (force_remove === true) {
      sessionStorage.removeItem(name);
      return null;
    } else {
      if (value != null) {
        sessionStorage.setItem(name, value.toString());
        return Number(value);
      } else {
        const r = sessionStorage.getItem(name);
        if (!r) {
          return null;
        } else {
          sessionStorage.removeItem(name);
          return Number(r);
        }
      }
    }
  }
  //  generico
  Session_Object(key: string, set_obj: any = null, force_remove: boolean = false): any | null {
    if (force_remove === true) {
      sessionStorage.removeItem(key);
      return null;
    }
    // set mode
    if (set_obj != null) {
      const js = JSON.stringify(set_obj);

      sessionStorage.setItem(key, window.btoa(js));
      return set_obj;
    } else {
      // get mode
      let r = sessionStorage.getItem(key);

      if (!r) {
        return null;
      } else {
        r = window.atob(r);
        return JSON.parse(r);
      }
    }
  }

  // ----------------
  ngOnDestroy(): void {
    this.subscriptions.forEach((elem) => {
      elem.unsubscribe();
    });
  }
}
